/**
 * @module services/indication-fallback-notice
 * @description UC-REG-259 — Aviso para el médico cuando la API emitió una
 *              receta de medicamento SIN el motor externo de recetas
 *              (fallback local por tenant, hoy solo Campana: la API marca la
 *              indicación con `issuedWithoutEngine: true` y manda el PDF
 *              local al paciente). El Dashboard no muestra error: el guardado
 *              fue exitoso, solo agrega este aviso. Si ninguna indicación
 *              trae la marca (resto de tenants, motor OK) devuelve null y no
 *              cambia nada.
 */

/**
 * @description Arma el texto del aviso según cuántas recetas salieron sin motor.
 * @param {Array<{issuedWithoutEngine?: boolean}>|undefined} createdIndications -
 *   indicaciones devueltas por `indicationService.saveIndications`
 * @returns {string|null} texto del aviso, o null si no aplica
 */
export function issuedWithoutEngineNotice(createdIndications) {
  const count = (createdIndications || []).filter(
    (indication) => indication && indication.issuedWithoutEngine
  ).length;
  if (count === 0) return null;
  const subject =
    count === 1 ? "1 receta se emitió" : `${count} recetas se emitieron`;
  return `${subject} sin validación electrónica (el servicio de recetas no respondió). Se envió el PDF al mail del paciente.`;
}
